export type DotLabelBadgeProps = {
  dotActive: boolean
  label: string
}
